/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramFavouritesUserControllerAddManyMutationRequest,
  TelegramFavouritesUserControllerAddManyMutationResponse,
  TelegramFavouritesUserControllerAddMany401,
} from '../../types/TelegramFavouritesUserControllerAddMany.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramFavouritesUserAddMany } from '../../methods/telegramFavouritesUserAddMany.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramFavouritesUserAddManyMutationKey = () => [{ url: '/api/user/telegram/favourites/many' }] as const;

export type TelegramFavouritesUserAddManyMutationKey = ReturnType<typeof telegramFavouritesUserAddManyMutationKey>;

/**
 * {@link /api/user/telegram/favourites/many}
 */
export function useTelegramFavouritesUserAddMany<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramFavouritesUserControllerAddManyMutationResponse,
      ResponseErrorConfig<TelegramFavouritesUserControllerAddMany401>,
      { data: TelegramFavouritesUserControllerAddManyMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramFavouritesUserControllerAddManyMutationRequest>> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramFavouritesUserAddManyMutationKey();

  return useMutation<
    TelegramFavouritesUserControllerAddManyMutationResponse,
    ResponseErrorConfig<TelegramFavouritesUserControllerAddMany401>,
    { data: TelegramFavouritesUserControllerAddManyMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramFavouritesUserAddMany(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
